<template>
  <b-modal
    hide-footer
    size="md"
    title="Mapping H2H Market"
    centered
    id="mapping-h2h"
    @shown="fetchMarketGroups"
  >
    <div class="text-black pt-2 pb-2">
      <b-row>
        <!-- List H2H -->
        <b-col cols="12" style="border-right: 1px solid #dae1e7">
          <div class="d-flex justify-content-between mb-1">
            <h5>List H2H</h5>
            <b-button
              variant="primary"
              style="padding: 6px 10px; font-size: 12px"
              @click="handleShowModalAddNewGroup"
              >Add new market</b-button
            >
          </div>

          <div class="d-flex align-items-center justify-content-between mb-1">
            <p class="text-muted m-0">
              <feather-icon icon="MoveIcon" class="mr-1" />
              Drag market to reorder display priority
            </p>
            <b-button
              variant="primary"
              size="sm"
              @click="handleSaveOrder"
              style="padding: 6px 10px; font-size: 12px"
              class="ml-1"
            >
              <feather-icon icon="SaveIcon" />
              Save order
            </b-button>
          </div>
          <draggable
            v-if="list.length > 0"
            :list="list"
            :group="{ name: 'list' }"
            :sort="true"
          >
            <div
              v-for="(group, index) in list"
              :key="group.id"
              class="d-flex align-items-center justify-content-between p-1"
              :class="{
                'border-bot': index !== list.length - 1,
              }"
              style="cursor: pointer; gap: 16px"
            >
              <div>
                <feather-icon icon="AlignCenterIcon" class="text-muted mr-1" />
                {{ group.name }}
              </div>
              <div>
                <feather-icon
                  icon="EditIcon"
                  size="16"
                  class="align-middle text-warning cursor-pointer"
                  style="margin-right: 8px"
                  @click="handleEditMarket(group)"
                />
                <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="align-middle cursor-pointer"
                  style="color: red"
                  @click="showModal('delete-market', group)"
                />
              </div>
            </div>
          </draggable>
        </b-col>
      </b-row>

      <!-- MODAL ADD/UPDATE MARKET -->
      <b-modal
        ref="add-market"
        title="Market Mapping"
        centered
        cancel-variant="outline-secondary"
        hide-footer
        no-close-on-backdrop
        @hide="hideModalSetting"
      >
        <div style="color: black" class="mb-2">
          <p class="m-0" style="padding-bottom: 5px">Sport</p>
          <v-select
            v-model="selectedSport"
            :options="sportList"
            :loading="loadingSports"
            label="name"
            :clearable="false"
            :searchable="false"
            placeholder="Select sport..."
            @input="onSportChange"
          />
        </div>
        <div style="color: black" class="mb-2">
          <p class="m-0" style="padding-bottom: 5px">Market Name</p>
          <v-select
            v-model="newMarket"
            :options="marketNameOptions"
            :loading="loadingMarketNameDropdown"
            :disabled="!selectedSport"
            label="name"
            :reduce="(opt) => opt.name"
            :filterable="false"
            placeholder="Select market name..."
            @search="onSearchMarketName"
          />
        </div>
        <b-row>
          <b-col class="d-flex justify-content-end">
            <b-button
              v-if="modalType === 'add'"
              variant="primary"
              class="mb-1 mb-sm-0"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isLoading"
              @click="handleSaveNewMarket"
            >
              <Spinner v-if="isLoading" />
              <template v-else> Save </template>
            </b-button>
            <b-button
              v-if="modalType === 'edit'"
              variant="primary"
              class="mb-1 mb-sm-0"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isLoading"
              @click="handleSaveUpdateMarket"
            >
              <Spinner v-if="isLoading" />
              <template v-else> Save </template>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <!-- MODAL CONFIRM -->
      <b-modal
        ref="modal"
        :title="modal.title"
        centered
        cancel-variant="outline-secondary"
        :ok-disabled="isLoading"
        @ok="handleSubmitModal"
      >
        <b-card-text style="color: black">
          {{ modal.content }}
        </b-card-text>
        <template #modal-ok>
          <Spinner v-if="isLoading" />
          <span v-else>Submit</span>
        </template>
      </b-modal>
    </div>
  </b-modal>
</template>

<script>
import useToastHandler from "@/services/toastHandler";
import {
  BCard,
  BCol,
  BRow,
  BButton,
  BIcon,
  BFormCheckbox,
  BFormInput,
  BCardText,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import { debounce } from "debounce";
import draggable from "vuedraggable";
import Spinner from "@/@core/components/Spinner.vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BIcon,
    BFormCheckbox,
    draggable,
    BFormInput,
    BCardText,
    Spinner,
    vSelect,
  },
  data() {
    return {
      list: [],
      checkActiveSport: true,
      modal: {
        title: "",
        content: "",
      },
      action: {
        type: "",
        id: "",
      },
      newMarket: "",
      modalType: "",
      editItem: null,
      marketNameOptions: [],
      sportList: [],
      selectedSport: null,
      loadingSports: false,
    };
  },
  watch: {},
  computed: {
    ...mapState("sport/market", [
      "loadingDelete",
      "loadingCreateMappingMarket",
      "loadingUpdateMarketName",
    ]),
    ...mapState("sport/sport-event-market", ["loadingMarketNameDropdown"]),
    isLoading() {
      return (
        this.loadingDelete ||
        this.loadingCreateMappingMarket ||
        this.loadingUpdateMarketName
      );
    },
  },
  methods: {
    ...mapActions({
      createMarketMappingH2H: "sport/market/createMarketMappingH2H",
      updateMappingH2HMarket: "sport/market/updateMappingH2HMarket",
      deleteCrawlingH2HMarket: "sport/market/deleteCrawlingH2HMarket",
      updateOrderNumberListMappingH2H:
        "sport/market/updateOrderNumberListMappingH2H",
      getListMappingH2H: "sport/market/getListMappingH2H",
      getListSport: "sport/list/getListSport",
      getMarketNameDropdown: "sport/sport-event-market/getMarketNameDropdown",
    }),
    onSportChange() {
      this.newMarket = "";
      this.marketNameOptions = [];
      if (this.selectedSport) this.fetchMarketNames("");
    },
    async fetchMarketNames(search) {
      if (!this.selectedSport) return;
      const data = await this.getMarketNameDropdown({
        sportName: this.selectedSport.name,
        ...(search && { search }),
      });
      this.marketNameOptions = Array.isArray(data) ? data : [];
    },
    async fetchSports() {
      this.loadingSports = true;
      try {
        const res = await this.getListSport({ limit: 100 });
        const data = res?.data || res || [];
        this.sportList = Array.isArray(data) ? data : [];
        if (this.sportList.length > 0) {
          this.selectedSport = this.sportList[0];
          await this.fetchMarketNames("");
        }
      } catch (e) {
        this.sportList = [];
      } finally {
        this.loadingSports = false;
      }
    },
    async fetchMarketGroups() {
      await Promise.all([
        this.getListMappingH2H().then((data) => {
          if (Array.isArray(data?.data)) this.list = data.data;
        }),
        this.fetchSports(),
      ]);
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete-market")
        this.setModal(
          "Delete Keyword",
          `Are you sure you want to delete market H2H crawling name ${item.name}?`
        );
      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { type, item } = this.action;
      if (type === "delete-market") await this.handleDelete(item);
      if (type === "delete-group") await this.handleDeleteGroup(item);

      if (!this.isLoading) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    hideModalSetting() {
      this.newMarket = "";
      this.marketNameOptions = [];
      if (this.sportList.length > 0) {
        this.selectedSport = this.sportList[0];
      }
    },
    async handleDelete(item) {
      const res = await this.deleteCrawlingH2HMarket(item.id);
      if (res) {
        this.showToastSuccess("This market deleted successfully!");
        this.handleReload();
      }
    },
    async handleReload() {
      await this.fetchMarketGroups();
    },
    handleAddMoreKey() {
      this.newGroup.keywords = [
        ...this.newGroup.keywords,
        {
          id: this.newGroup.keywords[this.newGroup.keywords.length - 1].id + 1,
          keyword: "",
        },
      ];
    },
    async handleSaveNewMarket(event) {
      event.preventDefault();
      if (!this.newMarket)
        return this.showToastError(false, "Please enter market name");
      const res = await this.createMarketMappingH2H({
        Name: this.newMarket,
        source: "sporting",
      });
      if (res) {
        this.showToastSuccess("Success", "Add new market successfully!");
        this.$refs["add-market"].hide();
        this.handleReload();
      }
    },
    async handleSaveUpdateMarket(event) {
      event.preventDefault();
      if (!this.newMarket)
        return this.showToastError(false, "Please enter market name");
      const res = await this.updateMappingH2HMarket({
        id: this.editItem.id,
        Name: this.newMarket,
        source: "sporting",
      });
      if (res) {
        this.showToastSuccess("Success", "Updated market successfully!");
        this.$refs["add-market"].hide();
        this.handleReload();
      }
    },
    async handleSaveOrder() {
      const res = await this.updateOrderNumberListMappingH2H({
        markets: this.list.map((i, ind) => {
          return {
            id: i.id,
            settingOrderNumber: ind + 1,
          };
        }),
      });
      if (res) {
        this.showToastSuccess("success", "Updated new order successfully!");
      }
    },
    handleShowModalAddNewGroup() {
      this.newMarket = "";
      this.modalType = "add";
      this.$refs["add-market"].show();
    },
    handleEditMarket(item) {
      this.editItem = item;
      this.newMarket = item.name;
      this.modalType = "edit";
      this.$refs["add-market"].show();
    },
  },
  created() {
    this.onSearchMarketName = debounce((search) => {
      if (!this.selectedSport) return;
      this.fetchMarketNames(search);
    }, 300);
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style lang="scss" scoped>
.border-bot {
  border-bottom: 1px solid #dae1e7;
}

.active-item {
  color: #0d6efd;
  font-weight: bold;
  border-left: 2px solid #0d6efd;
  background: #e7f1ff;
}

.market-outline {
  padding: 20px;
  border: 1px solid #dae1e7;
  border-radius: 10px;
}
</style>
